import VisitsScreenSingle from './VisitsScreenSingle';

export default VisitsScreenSingle;
